import { useEffect } from "react";

import { InteractionMode } from "components/server-types";
import { storeApi, useAppSelector } from "store/index";
import { selectCurrentCourseId } from "store/selectors";
import { isGroupInteractionMode } from "utils/page-utils";

export const useFetchGroupData = (pageId: string, interactionMode: InteractionMode) => {
  const courseId = useAppSelector(selectCurrentCourseId);

  useEffect(() => {
    if (!pageId || !courseId) {
      return;
    }

    storeApi.submissions.list({ page_id: pageId });
    storeApi.page_outcomes.list({ page_id: pageId });

    if (!isGroupInteractionMode(interactionMode)) {
      storeApi.page_groups.list({ page_id: pageId });
      storeApi.page_group_users.list({ page_group__page_id: pageId });
    } else if (interactionMode === InteractionMode.INDIVIDUAL) {
      storeApi.course_users.list({ section_id: courseId });
    }
  }, [interactionMode, pageId, courseId]);
};
